import './cookies';



// WEBPACK FOOTER //
// ./scripts/elements/cookies/index.js